import { DefaultPage, ThemeElevenFaq, ThemeElevenLos, ThemeElevenMaipu, ThemeElevenTerminalSur, ThemeSevenCompanyScreen } from '..';

import ArzolaFlota from '../ThemeThree/arzola/ArzolaFlota';
import ArzolaPrivacyPolicy from '../ThemeThree/arzola/ArzolaPrivacyPolicy';
import CommonAboutUsPage from '../common-pages/CommonAboutUsPage';
import CommonAgenciesPage from '../common-pages/CommonAgenciesPage';
import CommonCompanyPage from '../common-pages/CommonCompanyPage';
import CommonContactUsPage from '../common-pages/CommonContactUsPage';
import CommonDestinationPage from '../common-pages/CommonDestinationPage';
import CommonFaqPage from '../common-pages/CommonFaqPage';
import CommonGalleryPage from '../common-pages/CommonGalleryPage';
import CommonOfficesPage from '../common-pages/CommonOfficesPage';
import CommonParcelPage from '../common-pages/CommonParcelPage';
import CommonPrivacyPolicyPage from '../common-pages/CommonPrivacyPolicyPage';
import CommonServicesPage from '../common-pages/CommonServicesPage';
import CommonTnCPage from '../common-pages/CommonTnCPage';
import CommonWorkPage from '../common-pages/CommonWorkPage';
import IvergramaAboutUsScreen from '../Ivergrama/IvergramaPages/IvergramaAboutUsScreen';
import IvergramaContactUsScreen from '../Ivergrama/IvergramaPages/IvergramaContactUsScreen';
import IvergramaFaqScreen from '../Ivergrama/IvergramaPages/IvergramaFaqScreen';
import IvergramaServiceScreen from '../Ivergrama/IvergramaPages/IvergramaServiceScreen';
import IvergramaTnCScreen from '../Ivergrama/IvergramaPages/IvergramaTnCScreen';
import PullmanSanAndreasAbout from '../theme6/PullmanSanAndreasPage/PullmanSanAndreasAbout';
import PullmanSanAndreasContact from '../theme6/PullmanSanAndreasPage/PullmanSanAndreasContact';
import PullmanSanAndreasPrivacyPolicy from '../theme6/PullmanSanAndreasPage/PullmanSanAndreasPrivacyPolicy';
import PullmanSanAndreasSafety from '../theme6/PullmanSanAndreasPage/PullmanSanAndreasSafety';
import PullmanSanAndreasServices from '../theme6/PullmanSanAndreasPage/PullmanSanAndreasServices';
import PullmanSanAndreasTermsAndConditions from '../theme6/PullmanSanAndreasPage/PullmanSanAndreasTermsAndConditions';
import ThemeElevenPajatiros from '../ThemeEleven/pages/ThemeElevenPajatiros';
import ThemeNineBaggageTnCScreen from '../ThemeNine/ThemeNinePages/ThemeNineBaggageTnCScreen';
import ThemeNineCompanyScreen from '../ThemeNine/ThemeNinePages/ThemeNineCompanyScreen';
import ThemeNineContactScreen from '../ThemeNine/ThemeNinePages/ThemeNineContactScreen';
import ThemeNineFrequentPassengersScreen from '../ThemeNine/ThemeNinePages/ThemeNineFrequentPassengersScreen';
import ThemeNineMendozaTnCScreen from '../ThemeNine/ThemeNinePages/ThemeNineMendozaTnCScreen';
import ThemeNineOfficeScreen from '../ThemeNine/ThemeNinePages/ThemeNineOfficeScreen';
import ThemeNineRegulationTnCScreen from '../ThemeNine/ThemeNinePages/ThemeNineRegulationTnCScreen';
import ThemeNineSpecialServicesScreen from '../ThemeNine/ThemeNinePages/ThemeNineSpecialServicesScreen';
import ThemeNineWorkWithUs from '../ThemeNine/ThemeNinePages/ThemeNineWorkWithUs';
import ThemeSevenCargoScreen from '../ThemeSeven/ThemeSevenPages/ThemeSevenCargoScreen';
import ThemeSevenFrequentCard from '../ThemeSeven/ThemeSevenPages/ThemeSevenFrequentCard';
import ThemeSevenPriceAndServicesScreen from '../ThemeSeven/ThemeSevenPages/ThemeSevenPriceAndServicesScreen';
import ThemeSevenSpecialServicesScreen from '../ThemeSeven/ThemeSevenPages/ThemeSevenSpecialServicesScreen';
import ThemeSevenTicketSaleScreen from '../ThemeSeven/ThemeSevenPages/ThemeSevenTicketSaleScreen';
import ThemeTenServiciosEspeciales from '../ThemeTen/ThemeTenPages/ThemeTenServiciosEspeciales';
import ThemeTenTravelNorth from '../ThemeTen/ThemeTenPages/ThemeTenTravelNorth';
import ThemeThreeFleets from '../ThemeThree/ThemeThreePages/ThemeThreeGallery';
import ThemeThreeGallery from '../ThemeThree/ThemeThreePages/ThemeThreeGallery';
import ThemeTwoOfficeSection from '../ThemeTwo/common/ThemeTwoOfficeSection';
import ThemeTwoPrivacyPolicy from '../ThemeTwo/common/ThemeTwoPrivacyPolicy';
import arzolaOffices from '../ThemeThree/arzola/arzolaOffices';
import chilebusaboutus from '../ThemeFour/Chilebus/ChilebusAboutus';

;

const routes = [
	// Theme Five Routes => Tepual , apaeroNorte
	{ path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },

	{
		path: '/destinos',
		name: 'Destinations',
		component: CommonDestinationPage,
		isIndex: false,
	},
	{ path: '/Agencies', name: 'Agencies page', component: CommonAgenciesPage, isIndex: false },

	{ path: '/about-us', name: 'AboutUs page', component: CommonAboutUsPage, isIndex: false },
	{ path: '/travel-norte', name: 'AboutUs page', component: ThemeTenTravelNorth, isIndex: false },
	{ path: '/servicios-especiales', name: 'service page', component: ThemeTenServiciosEspeciales, isIndex: false },

	{
		path: '/terms',
		name: 'Terms and Conditions',
		component: CommonTnCPage,
		isIndex: false,
	},
	{ path: '/office', name: 'Offices', component: CommonOfficesPage, isIndex: false },
	{ path: '/gallery', name: 'Gallery', component: CommonGalleryPage, isIndex: false },
	{ path: '/contact', name: 'Contact', component: CommonContactUsPage, isIndex: false },

	// Theme One  Routes =>   Andimar
	{ path: '/fleet', name: 'Fleet', component: CommonGalleryPage, isIndex: false },
	{
		path: '/privacy-policy',
		name: 'PrivacyPolicy',
		component: CommonPrivacyPolicyPage,
		isIndex: false,
	},

	// PULLMAN SAN ANDREAS
	{ path: '/sanandres-about', name: 'About', component: PullmanSanAndreasAbout, isIndex: false },
	{ path: '/safety', name: 'Safety', component: PullmanSanAndreasSafety, isIndex: false },
	{
		path: '/inter-regional-travel',
		name: 'Services',
		component: PullmanSanAndreasServices,
		isIndex: false,
	},
	{
		path: '/sanandres-contact',
		name: 'Contact',
		component: PullmanSanAndreasContact,
		isIndex: false,
	},
	{
		path: '/sanandres-privacy-policy',
		name: 'Privacy Policy',
		component: PullmanSanAndreasPrivacyPolicy,
		isIndex: false,
	},
	{
		path: '/sanandres-terms-and-conditions',
		name: 'Terms and Conditions',
		component: PullmanSanAndreasTermsAndConditions,
		isIndex: false,
	},


	{ path: '/ivergrama-contact', name: 'Contact', component: IvergramaContactUsScreen, isIndex: false },
	{ path: '/ivergrama-services', name: 'Contact', component: IvergramaServiceScreen, isIndex: false },
	{ path: '/ivergrama-faq', name: 'faq', component: IvergramaFaqScreen, isIndex: false },
	{
		path: '/ivergrama-terms',
		name: 'Terms and Conditions',
		component: IvergramaTnCScreen,
		isIndex: false,
	},

	{ path: '/about-ivergrama', name: 'AboutUs page', component: IvergramaAboutUsScreen, isIndex: false },


	{ path: '/norte-contact', name: 'Contact', component: CommonContactUsPage, isIndex: false },
	{ path: '/norte-office', name: 'Offices', component: CommonOfficesPage, isIndex: false },
	{ path: '/About us', name: 'About Us', component: CommonAboutUsPage, isIndex: false },
	{ path: '/norte-flota', name: 'flota', component: CommonGalleryPage, isIndex: false },
	{ path: '/aeroquinta-contact', name: 'Contact', component: CommonContactUsPage, isIndex: false },
	// { path: '/aeroquinta-terms', name: 'Offices', component: CommonOfficesPage, isIndex: false },
	{ path: '/aeroquinta-terms', name: 'Terms and Conditions', component: CommonTnCPage, isIndex: false },
	{ path: '/About-aeroquinta', name: 'About Us', component: CommonAboutUsPage, isIndex: false },
	{ path: '/aeroquinta-fleet', name: 'flota', component: CommonGalleryPage, isIndex: false },

	{ path: '/services', name: 'Contact', component: IvergramaServiceScreen, isIndex: false },
	{
		path: '/saopaulo-destinos',
		name: 'Destinations',
		component: CommonDestinationPage,
		isIndex: false,
	},

	{
		path: '/saopaulo-terms',
		name: 'Terms and Conditions',
		component: CommonTnCPage,
		isIndex: false,
	},

	{ path: '/saopaulo-contact', name: 'Contact', component: CommonContactUsPage, isIndex: false },
	{ path: '/saopaulo-office', name: 'Offices', component: CommonOfficesPage, isIndex: false },

	{ path: '/about-saopaulo', name: 'AboutUs page', component: CommonAboutUsPage, isIndex: false },

	//Santa Juana Routes
	{
		path: '/juana-work',
		name: 'Trabaja',
		component: CommonWorkPage,
		isIndex: false,
	},

	{ path: '/juana-contact', name: 'Contact', component: CommonContactUsPage, isIndex: false },
	{ path: '/juana-office', name: 'Offices', component: CommonOfficesPage, isIndex: false },
	{ path: '/about-juana', name: 'AboutUs page', component: CommonAboutUsPage, isIndex: false },





	//arzola pages

	{ path: '/', name: 'Incio', component: ThemeNineOfficeScreen, isIndex: true },
	{ path: '/la-empresa', name: 'About Us', component: CommonAboutUsPage, isIndex: false },
	{ path: '/arzola-contact', name: 'Contact', component: IvergramaContactUsScreen, isIndex: false },
	{ path: '/Privacy-policies', name: 'Privacy Policy', component: ArzolaPrivacyPolicy, isIndex: false },
	// { path: '/arzola-flota', name: 'Privacy Policy', component: ArzolaFlota, isIndex: false },
	{ path: '/Sucursales', name: 'Sucursales', component: arzolaOffices, isIndex: false },

	{ path: '/santarosa-privacy-policy', name: 'Contact', component: ThemeTwoPrivacyPolicy, isIndex: false },
	{ path: '/buseslafit-privacy-policy', name: 'Contact', component: ThemeTwoPrivacyPolicy, isIndex: false },

	// chilebus Routes Theme Four
	{
		path: '/chilebus-destinos',
		name: 'Destinations',
		component: CommonDestinationPage,
		isIndex: false,
	},
	{ path: '/about-chilebus', name: 'AboutUs page', component: CommonAboutUsPage, isIndex: false },
	// ----------------------------------------------------------------
	{
		path: '/pullmandelsur-destinos',
		name: 'Destinations',
		component: CommonDestinationPage,
		isIndex: false,
	},

	{
		path: '/chilebus-terms',
		name: 'Terms and Conditions',
		component: CommonTnCPage,
		isIndex: false,
	},

	{
		path: '/pullmandelsur-terms',
		name: 'Terms and Conditions',
		component: CommonTnCPage,
		isIndex: false,
	},

	{
		path: '/chilebus-terms',
		name: 'Terms and Conditions',
		component: CommonTnCPage,
		isIndex: false,
	},

	{ path: '/chilebus-contact', name: 'Contact', component: CommonContactUsPage, isIndex: false },
	{ path: '/chilebus-office', name: 'Offices', component: CommonOfficesPage, isIndex: false },

	//{ path: '/about-chilebus', name: 'AboutUs page', component: CommonAboutUsPage, isIndex: false },
	{
		path: '/pullmandelsur-contact',
		name: 'Contact',
		component: CommonContactUsPage,
		isIndex: false,
	},
	{ path: '/pullmandelsur-office', name: 'Offices', component: CommonOfficesPage, isIndex: false },

	{
		path: '/about-pullmandelsur',
		name: 'AboutUs page',
		component: CommonAboutUsPage,
		isIndex: false,
	},
	{
		path: '/pullmandelsur-Encomiendas',
		name: 'Parcel Page',
		component: CommonParcelPage,
		isIndex: false,
	},

	// ThemeSeven Routes
	{
		path: '/terms-conditions',
		name: 'Terms and Conditions',
		component: CommonTnCPage,
		isIndex: false,
	},

	{
		path: '/cargo',
		name: 'Servicios de carga',
		component: ThemeSevenCargoScreen,
		isIndex: false,
	},

	{
		path: '/special-service',
		name: 'Traslado de pasajeros',
		component: ThemeSevenSpecialServicesScreen,
		isIndex: false,
	},

	{
		path: '/prices-and-services',
		name: 'Precios y servicios',
		component: ThemeSevenPriceAndServicesScreen,
		isIndex: false,
	},
	{
		path: '/frequent-card',
		name: 'Tarjeta de viajero frecuente',
		component: ThemeSevenFrequentCard,
		isIndex: false,
	},

	{
		path: '/company',
		name: 'Nuestras empresas',
		component: CommonCompanyPage,
		isIndex: false,
	},

	{
		path: '/ticket-sales',
		name: 'Nuestras empresas',
		component: ThemeSevenTicketSaleScreen,
		isIndex: false,
	},

	//Theme Nine routes
	{
		path: '/company-ahumada',
		name: ' empresas',
		component: ThemeNineCompanyScreen,
		isIndex: false,
	},

	{
		path: '/company-thaebus',
		name: ' empresas',
		component: ThemeNineCompanyScreen,
		isIndex: false,
	},

	{
		path: '/work-with-us',
		name: 'Work with us',
		component: ThemeNineWorkWithUs,
		isIndex: false,
	},

	{
		path: '/contact-ahumada',
		name: ' Contact ahumada',
		component: ThemeNineContactScreen,
		isIndex: false,
	},

	{
		path: '/contact-thaebus',
		name: ' Contact thaebus',
		component: ThemeNineContactScreen,
		isIndex: false,
	},

	{
		path: '/offices-ahumada',
		name: ' Offices',
		component: ThemeNineOfficeScreen,
		isIndex: false,
	},

	{
		path: '/offices-thaebus',
		name: ' Offices',
		component: ThemeNineOfficeScreen,
		isIndex: false,
	},

	{
		path: '/travel-to-mendoza',
		name: ' Travel to Mendoza',
		component: ThemeNineMendozaTnCScreen,
		isIndex: false,
	},

	{
		path: '/regulation',
		name: ' Regulations',
		component: ThemeNineRegulationTnCScreen,
		isIndex: false,
	},

	{
		path: '/tnc-thaebus',
		name: ' Tnc Thaebus',
		component: ThemeNineMendozaTnCScreen,
		isIndex: false,
	},

	{
		path: '/baggage',
		name: ' Baggage',
		component: ThemeNineBaggageTnCScreen,
		isIndex: false,
	},

	{
		path: '/frequent-passengers',
		name: ' Frequent Passengers',
		component: ThemeNineFrequentPassengersScreen,
		isIndex: false,
	},

	{
		path: '/services-special',
		name: ' Services Special',
		component: ThemeNineSpecialServicesScreen,
		isIndex: false,
	},

	{
		path: '/terminalsur',
		name: 'terminalsur',
		component: ThemeElevenTerminalSur,
		isIndex: false,
	},

	{
		path: '/pajaritos',
		name: 'pajaritos',
		component: ThemeElevenPajatiros,
		isIndex: false,
	},


	{
		path: '/maipu',
		name: 'Maipu',
		component: ThemeElevenMaipu,
		isIndex: false,
	},

	{
		path: '/los',
		name: 'los',
		component: ThemeElevenLos,
		isIndex: false,
	},


	{
		path: '/faq',
		name: 'faq',
		component: ThemeElevenFaq,
		isIndex: false,
	},


	{ path: '/torres-faq', name: 'faq', component: IvergramaFaqScreen, isIndex: false },
	{ path: '/about-torres', name: 'AboutUs page', component: IvergramaAboutUsScreen, isIndex: false },
	{ path: '/torres-contact', name: 'Contact', component: IvergramaContactUsScreen, isIndex: false },
	{
		path: '/torres-terms',
		name: 'Terms and Conditions',
		component: CommonTnCPage,
		isIndex: false,
	},
	{ path: '/torres-services', name: 'Contact', component: IvergramaServiceScreen, isIndex: false },
];
const getRoutes = () => {
	return routes;
};

export default getRoutes;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getRoutes.js